import { createContext } from 'react';
const mailContext = createContext();
export default mailContext;
